import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Survey from "@/views/Survey.vue";
import Delete from "@/views/Delete.vue";
import SurveyQRView from "@/views/SurveyQRView.vue";
import SurveyEditor from "@/views/SurveyEditor.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Survey",
    component: Survey
  },
  {
    path: "/editor",
    name: "SurveyEditor",
    component: SurveyEditor,
    meta: { layout: "editor" }
  },
  {
    path: "/delete",
    name: "Delete",
    component: Delete
  },
  {
    path: "/qrview",
    name: "SurveyQRView",
    component: SurveyQRView
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,

  routes
});

export default router;
